// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.productDetail_productDetail__xou5Z .productDetail_wrapper__U7uR7 div div .productDetail_coverImg__6H9WO {
  width: 100%;
  height: 350px;
  object-fit: cover;
  object-position: center;
}`, "",{"version":3,"sources":["webpack://./src/styles/productDetail.module.scss"],"names":[],"mappings":"AAII;EACC,WAAA;EACA,aAAA;EACA,iBAAA;EACA,uBAAA;AAHL","sourcesContent":[".productDetail {\n\t.wrapper {\n\t\tdiv {\n\t\t\tdiv {\n\t\t\t\t.coverImg {\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\theight: 350px;\n\t\t\t\t\tobject-fit: cover;\n\t\t\t\t\tobject-position: center;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"productDetail": `productDetail_productDetail__xou5Z`,
	"wrapper": `productDetail_wrapper__U7uR7`,
	"coverImg": `productDetail_coverImg__6H9WO`
};
export default ___CSS_LOADER_EXPORT___;
